// Datadog browser identity, shared by the RUM/browser-logs init
// (src/lib/hooks/use-datadog.tsx) and the CSP report-uri built in
// ./security-headers.mjs for next.config.mjs. `.mjs` so next.config can import it.
//
// The client token is Datadog's PUBLIC, write-only browser token: it ships in the
// client bundle by design and is not a secret.
export const DATADOG_CLIENT_TOKEN = 'pub4c22af0953296b868dc584cd8ea4cb98'

// US1. The CSP intake host in ./security-headers.mjs is the US1 one; a site
// change has to move both.
export const DATADOG_SITE = 'datadoghq.com'
